import { atom } from 'recoil';

import * as api from '@gitbook/api-client';

/**
 * State to control the site preview.
 */
export const sitePreviewAtom = atom<{
    device: 'desktop' | 'mobile';
    theme: api.CustomizationThemeMode;
}>({
    key: 'sitePreview',
    default: {
        device: 'desktop',
        theme: api.CustomizationThemeMode.Light,
    },
});
